/**
 * 深色背景 环图
 * @param unit 单位
 * @param dataArr [{name:'',value:0}]数据合集
 */
import { dealBigNum, amountFun } from "@/assets/js/utils";
export function setOption(paramObj) {
  let tol = amountFun(paramObj.dataArr);
  let colorList = [
    { color: "#16C0BA", color1: "#31E9E5" },
    { color: "#309DF6", color1: "#43B9EB" },
    { color: "#6569FF", color1: "#9EA2FF" },
    { color: "#CADFCA", color1: "#C0D6C0" },
  ];
  let option = {
    title: {
      text: "总数",
      x: "center",
      y: "39%",
      textStyle: {
        color: "#16E9F4",
        fontSize: 12,
        align: "center",
      },
      subtext: tol == 0 ? "0" : tol,
      subtextStyle: {
        fontSize: 16,
        color: "#fff",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: function (param) {
        return `${param.name}:${dealBigNum(param.value)}${paramObj.unit} ${
          param.percent == undefined || param.percent < 0.01
            ? 0.01
            : param.percent
        }%`;
      },
    },
    series: [
      {
        type: "pie",
        minAngle: 10, // label最小扇区大小
        radius: ["45%", "65%"],
        center: ["50%", "50%"],
        data: paramObj.dataArr,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        itemStyle: {
          color: (params) => {
            return {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: colorList[params.dataIndex].color1,
                },
                {
                  offset: 1,
                  color: colorList[params.dataIndex].color,
                },
              ],
            };
          },
        },
        label: {
          alignTo: "edge",
          edgeDistance: 35, // 布局为两端对称时候需要外边距防止图表变形 数值随意不要太大
          distanceToLabelLine: 0,
          formatter: function (param) {
            return (
              "{d|" +
              (param.percent == undefined || param.percent < 0.01
                ? 0.01
                : param.percent) +
              "%}\n" +
              "{b|" +
              param.name +
              "}"
            );
          },
          rich: {
            d: {
              color: "#FFFFFF",
              fontSize: 16,
              fontWeight: "bold",
              lineHeight: 18,
            },
            b: {
              color: "#A1A7B8",
              fontSize: 12,
              height: 15,
            },
          },
        },
      },
    ],
  };

  return option;
}
